const apiConfig = {
   
    api_url:"https://nimble.labofchoice.com/api/index.php",
  }
  
  export default apiConfig
  